import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CompressorMaintenanceWidget = ({
  width = 257,
  height = 207,
  fillColor,
  borderColor,
  ...rest
}: {
  width: number;
  height: number;
  fillColor?: string;
  borderColor?: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentFillColor = fillColor ?? token.colorBgContainer;
  const currentBorderColor = borderColor ?? null;

  return (
    <svg width={width} height={height} viewBox="0 0 257 207" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g filter="url(#filter0_ddd_25491_5387)">
        <path
          d="M5.5 12.5C5.5 8.08172 9.08172 4.5 13.5 4.5H243.5C247.918 4.5 251.5 8.08172 251.5 12.5V192.5C251.5 196.918 247.918 200.5 243.5 200.5H13.5C9.08173 200.5 5.5 196.918 5.5 192.5V12.5Z"
          fill={currentFillColor}
          shapeRendering="crispEdges"
        />
        <path
          d="M5.5 12.5C5.5 8.08172 9.08172 4.5 13.5 4.5H243.5C247.918 4.5 251.5 8.08172 251.5 12.5V192.5C251.5 196.918 247.918 200.5 243.5 200.5H13.5C9.08173 200.5 5.5 196.918 5.5 192.5V12.5Z"
          stroke={currentBorderColor}
          strokeDasharray="2 2"
          shapeRendering="crispEdges"
        />
        <path
          d="M5.5 12.5C5.5 8.08172 9.08172 4.5 13.5 4.5H243.5C247.918 4.5 251.5 8.08172 251.5 12.5V34.5H5.5V12.5Z"
          fill={currentFillColor}
        />
        <path
          d="M5.5 12.5C5.5 8.08172 9.08172 4.5 13.5 4.5H243.5C247.918 4.5 251.5 8.08172 251.5 12.5V34.5H5.5V12.5Z"
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <mask id="path-3-inside-1_25491_5387" fill="white">
          <path d="M5.5 34.5H251.5V92.5H5.5V34.5Z" />
        </mask>
        <path
          d="M251.5 92.5V91.5H5.5V92.5V93.5H251.5V92.5Z"
          fill={token.colorBorderSecondary}
          mask="url(#path-3-inside-1_25491_5387)"
        />
        <mask id="path-5-inside-2_25491_5387" fill="white">
          <path d="M5.5 42.5C5.5 38.0817 9.08172 34.5 13.5 34.5H195.5V92.5H5.5V42.5Z" />
        </mask>
        <path
          d="M5.5 34.5H195.5H5.5ZM195.5 92.5H5.5H195.5ZM5.5 92.5V34.5V92.5ZM196.5 34.5V92.5H194.5V34.5H196.5Z"
          fill={token.colorBorderSecondary}
          mask="url(#path-5-inside-2_25491_5387)"
        />
      </g>
      <path
        d="M251.5 112.5H253.5C254.605 112.5 255.5 113.395 255.5 114.5V122.5C255.5 123.605 254.605 124.5 253.5 124.5H251.5V112.5Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_25491_5387"
          x="0"
          y="0"
          width="257"
          height="207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25491_5387" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_25491_5387" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_25491_5387" result="effect2_dropShadow_25491_5387" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_25491_5387" result="effect3_dropShadow_25491_5387" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_25491_5387" result="shape" />
        </filter>
        <clipPath id="clip0_25491_5387">
          <rect width="19.8621" height="19.8621" fill="white" transform="translate(19.5 55.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CompressorMaintenanceWidget;
